export default "__VITE_ASSET__hzbT7hMI__"